import React, { Fragment } from "react";
import JournalCard from "../components/JournalCard";
import Navbar from "../components/Navbar";
import StoreHeader from "../components/StoreHeader";
import StoreLandingCard from "../components/StoreLandingCard";
import Testimonials from "../components/Testimonials";
import FrontAbstract from "./../assets/journals/frontabstract.jpg";
import FrontField from "./../assets/journals/frontfield.jpg";

const Store = () => {
  return (
    <Fragment>
      <div className="bg-cream h-full px-8 py-12 md:px-16 md:py-24">
        <Navbar />
        <StoreHeader />
        <StoreLandingCard />
      </div>
      <div className="mt-24 md:py-24 md:px-20 px-8 py-12">
        <JournalCard
          imgTitle={FrontAbstract}
          journalType="Abstract"
          url={"/cart/abstract-design"}
        />
        <JournalCard
          imgTitle={FrontField}
          journalType="Field"
          url={"/cart/field-design"}
        />
      </div>
      <Testimonials />
    </Fragment>
  );
};

export default Store;
